function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 141.7c0 70.7-51.8 129.4-119.6 140v-99h33l6.3-41h-39.3v-26.6c0-2.5.3-4.9.9-7.2 0-.1.1-.3.1-.4.4-1.5 1-2.9 1.7-4.3C169.7 97.3 176 93 187 93h17.9V58.1s-16.2-2.8-31.7-2.8c-16.2 0-29.6 4.9-38.9 14.3-9.3 9.3-14.6 23.1-14.6 40.9v31.2h-36v41h36v99C51.8 271.1 0 212.5 0 141.7 0 63.5 63.5 0 141.7 0s141.8 63.5 141.8 141.7z"
})));